import React from "react";
import cs from "classnames";

import { useABFlag } from "@lululemon/mwa-ab-testing/esm/components/ABFlags/useABFlag";

import ProductDescriptionPill from "../product-description-pill/index";

export default function PillsContainer({
  footwearReturnsPolicyModal,
  isEarlyAccessEnabled,
  isFootwear,
  locale,
  pills,
  styles = {}
}) {
  const pdpReviewRatingABFlag = useABFlag("pdpReviewRating");

  const FootwearReturnsPolicyModal = footwearReturnsPolicyModal;

  return !isEarlyAccessEnabled ? (
    <div
      className={cs(
        styles.pillContainer,
        pdpReviewRatingABFlag ? styles.pillReviewsContainer : ""
      )}
    >
      {pills?.map(({ key, ...props }) => (
        <ProductDescriptionPill
          key={key}
          {...props}
          className={`${styles.pdpPill} ${
            pdpReviewRatingABFlag ? styles.reviewsPill : ""
          }`}
        />
      ))}
      {isFootwear && footwearReturnsPolicyModal && (
        <FootwearReturnsPolicyModal
          type="pdp"
          locale={locale}
          classes={{
            wrapper: cs({
              [styles.reviewsPill]: pdpReviewRatingABFlag
            })
          }}
        />
      )}
    </div>
  ) : null;
}
